import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookSquare, faGithubSquare } from '@fortawesome/free-brands-svg-icons'
import { faSun, faMoon, faHome, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
library.add(faSun, faMoon, faHome, faFacebookSquare, faGithubSquare, faBars, faTimes);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
